import { render } from "./CgWorkShop.vue?vue&type=template&id=e78267d6&scoped=true"
import script from "./CgWorkShop.vue?vue&type=script&lang=js"
export * from "./CgWorkShop.vue?vue&type=script&lang=js"

import "./CgWorkShop.vue?vue&type=style&index=0&id=e78267d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e78267d6"]])

export default __exports__